import {
  dailyNiyam,
  festivalNiyam,
  INiyam,
  navpadjiniOliNiyam,
  tithiNiyamWithAyambilTap,
  tithiNiyamWithTap,
} from './niyam';

interface CalendarEvents {
  auspiciousEvent?: string;
  tithi: string;
  events?: [];
  niyam?: INiyam;
  shubhDivas?: boolean;
}

export const calendarDays = new Map<string, CalendarEvents>([]);

// Kartak Month
// eslint-disable-next-line no-lone-blocks
{
  calendarDays.set('2024-11-02', {
    tithi: 'Kartak Sud Ekam',
    niyam: dailyNiyam[17],
    shubhDivas: true,
  });

  calendarDays.set('2024-11-03', {
    tithi: 'Kartak Sud Bij',
    niyam: dailyNiyam[8],
    shubhDivas: true,
  });

  calendarDays.set('2024-11-04', {
    tithi: 'Kartak Sud Trij',
    niyam: dailyNiyam[9],
    shubhDivas: true,
  });

  calendarDays.set('2024-11-05', {
    tithi: 'Kartak Sud Chauth',
    niyam: dailyNiyam[10],
  });

  calendarDays.set('2024-11-06', {
    tithi: 'Kartak Sud Pancham',
    niyam: tithiNiyamWithTap,
    shubhDivas: true,
  });

  calendarDays.set('2024-11-07', {
    tithi: 'Kartak Sud Chatth',
    niyam: dailyNiyam[11],
    shubhDivas: true,
  });

  calendarDays.set('2024-11-08', {
    tithi: 'Kartak Sud Satam',
    niyam: dailyNiyam[12],
    shubhDivas: true,
  });

  calendarDays.set('2024-11-09', {
    tithi: 'Kartak Sud Aatham',
    niyam: tithiNiyamWithTap,
  });

  calendarDays.set('2024-11-10', {
    tithi: 'Kartak Sud Nom',
    niyam: dailyNiyam[13],
  });

  calendarDays.set('2024-11-11', {
    tithi: 'Kartak Sud Dasham',
    niyam: dailyNiyam[14],
    shubhDivas: true,
  });

  calendarDays.set('2024-11-12', {
    tithi: 'Kartak Sud Agyaras',
    niyam: dailyNiyam[15],
  });

  calendarDays.set('2024-11-13', {
    tithi: 'Kartak Sud Baras',
    niyam: dailyNiyam[16],
    shubhDivas: true,
  });

  calendarDays.set('2024-11-14', {
    tithi: 'Kartak Sud Chaudas',
    niyam: tithiNiyamWithTap,
  });

  calendarDays.set('2024-11-15', {
    tithi: 'Kartak Sud Poonam',
    niyam: dailyNiyam[7],
  });

  calendarDays.set('2024-11-16', {
    tithi: 'Kartak Vad Ekam',
    niyam: dailyNiyam[18],
  });

  calendarDays.set('2024-11-17', {
    tithi: 'Kartak Vad Bij',
    niyam: dailyNiyam[19],
    shubhDivas: true,
  });

  calendarDays.set('2024-11-18', {
    tithi: 'Kartak Vad Trij',
    niyam: dailyNiyam[20],
  });

  calendarDays.set('2024-11-19', {
    tithi: 'Kartak Vad Chauth',
    niyam: dailyNiyam[21],
  });

  calendarDays.set('2024-11-20', {
    tithi: 'Kartak Vad Pancham',
    niyam: dailyNiyam[22],
    shubhDivas: true,
  });

  calendarDays.set('2024-11-21', {
    tithi: 'Kartak Vad Chatth',
    niyam: dailyNiyam[23],
    shubhDivas: true,
  });

  calendarDays.set('2024-11-22', {
    tithi: 'Kartak Vad Satam',
    niyam: dailyNiyam[24],
  });

  calendarDays.set('2024-11-23', {
    tithi: 'Kartak Vad Aatham',
    niyam: tithiNiyamWithTap,
  });

  calendarDays.set('2024-11-24', {
    tithi: 'Kartak Vad Nom',
    niyam: dailyNiyam[25],
  });

  calendarDays.set('2024-11-25', {
    tithi: 'Kartak Vad Dasham',
    niyam: dailyNiyam[26],
    shubhDivas: true,
  });

  calendarDays.set('2024-11-26', {
    tithi: 'Kartak Vad Agyaras',
    niyam: dailyNiyam[27],
  });

  calendarDays.set('2024-11-27', {
    tithi: 'Kartak Vad Baras',
    niyam: dailyNiyam[28],
    shubhDivas: true,
  });
  calendarDays.set('2024-11-28', {
    tithi: 'Kartak Vad Teras 1',
    niyam: dailyNiyam[29],
  });
  calendarDays.set('2024-11-29', {
    tithi: 'Kartak Vad Teras 2',
    niyam: dailyNiyam[30],
  });
  calendarDays.set('2024-11-30', {
    tithi: 'Kartak Vad Chaudas',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2024-12-01', {
    tithi: 'Kartak Vad Amas',
    niyam: dailyNiyam[31],
  });
}

// Magshar Month
// eslint-disable-next-line no-lone-blocks
{
  calendarDays.set('2024-12-02', {
    tithi: 'Magshar Sud Ekam',
    niyam: dailyNiyam[32],
  });

  calendarDays.set('2024-12-03', {
    tithi: 'Magshar Sud Bij',
    niyam: dailyNiyam[33],
  });

  calendarDays.set('2024-12-04', {
    tithi: 'Magshar Sud Trij',
    niyam: dailyNiyam[34],
  });

  calendarDays.set('2024-12-05', {
    tithi: 'Magshar Sud Chauth',
    niyam: dailyNiyam[35],
  });

  calendarDays.set('2024-12-06', {
    tithi: 'Magshar Sud Pancham',
    niyam: tithiNiyamWithTap,
    shubhDivas: true,
  });

  calendarDays.set('2024-12-07', {
    tithi: 'Magshar Sud Chatth',
    niyam: dailyNiyam[36],
  });

  calendarDays.set('2024-12-08', {
    tithi: 'Magshar Sud Satam',
    niyam: dailyNiyam[37],
  });

  calendarDays.set('2024-12-09', {
    tithi: 'Magshar Sud Aatham',
    niyam: tithiNiyamWithTap,
  });

  calendarDays.set('2024-12-10', {
    tithi: 'Magshar Sud Dasham',
    niyam: dailyNiyam[38],
  });

  calendarDays.set('2024-12-11', {
    tithi: 'Magshar Sud Agyaras',
    niyam: tithiNiyamWithAyambilTap,
    auspiciousEvent: 'Maun Ekadashi',
    shubhDivas: true,
  });

  calendarDays.set('2024-12-12', {
    tithi: 'Magshar Sud Baras',
    niyam: dailyNiyam[40],
    shubhDivas: true,
  });

  calendarDays.set('2024-12-13', {
    tithi: 'Magshar Sud Teras',
    niyam: dailyNiyam[41],
  });

  calendarDays.set('2024-12-14', {
    tithi: 'Magshar Sud Chaudas',
    niyam: tithiNiyamWithTap,
  });

  calendarDays.set('2024-12-15', {
    tithi: 'Magshar Sud Poonam',
    niyam: dailyNiyam[42],
    shubhDivas: true,
  });

  calendarDays.set('2024-12-16', {
    tithi: 'Magshar Vad Ekam',
    niyam: dailyNiyam[43],
  });

  calendarDays.set('2024-12-17', {
    tithi: 'Magshar Vad Bij',
    niyam: dailyNiyam[44],
  });

  calendarDays.set('2024-12-18', {
    tithi: 'Magshar Vad Trij',
    niyam: dailyNiyam[45],
  });

  calendarDays.set('2024-12-19', {
    tithi: 'Magshar Vad Chauth',
    niyam: dailyNiyam[46],
  });

  calendarDays.set('2024-12-20', {
    tithi: 'Magshar Vad Pancham',
    niyam: dailyNiyam[47],
    shubhDivas: true,
  });

  calendarDays.set('2024-12-21', {
    tithi: 'Magshar Vad Chatth',
    niyam: dailyNiyam[48],
  });

  calendarDays.set('2024-12-22', {
    tithi: 'Magshar Vad Satam',
    niyam: dailyNiyam[49],
  });

  calendarDays.set('2024-12-23', {
    tithi: 'Magshar Vad Aatham',
    niyam: tithiNiyamWithTap,
    shubhDivas: true,
  });

  calendarDays.set('2024-12-24', {
    tithi: 'Magshar Vad Nom',
    niyam: dailyNiyam[50],
  });

  calendarDays.set('2024-12-25', {
    tithi: 'Magshar Vad Dasham',
    niyam: dailyNiyam[51],
    shubhDivas: true,
  });

  calendarDays.set('2024-12-26', {
    tithi: 'Magshar Vad Agyaras',
    niyam: dailyNiyam[52],
    shubhDivas: true,
  });

  calendarDays.set('2024-12-27', {
    tithi: 'Magshar Vad Baras',
    niyam: dailyNiyam[53],
    shubhDivas: true,
  });
  calendarDays.set('2024-12-28', {
    tithi: 'Magshar Vad Teras',
    niyam: dailyNiyam[54],
  });
  calendarDays.set('2024-12-29', {
    tithi: 'Magshar Vad Chaudas',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2024-12-30', {
    tithi: 'Magshar Vad Amas',
    niyam: dailyNiyam[55],
  });
}

// Posh month
// eslint-disable-next-line no-lone-blocks
{
  calendarDays.set('2024-12-31', {
    tithi: 'Posh Sud Ekam',
    niyam: dailyNiyam[56],
  });
  calendarDays.set('2025-01-01', {
    tithi: 'Posh Sud Bij',
    niyam: dailyNiyam[57],
    shubhDivas: true,
  });
  calendarDays.set('2025-01-02', {
    tithi: 'Posh Sud Trij',
    niyam: dailyNiyam[58],
    shubhDivas: true,
  });
  calendarDays.set('2025-01-03', {
    tithi: 'Posh Sud Chauth',
    niyam: dailyNiyam[59],
  });
  calendarDays.set('2025-01-04', {
    tithi: 'Posh Sud Pancham',
    niyam: tithiNiyamWithTap,
    shubhDivas: true,
  });
  calendarDays.set('2025-01-05', {
    tithi: 'Posh Sud Chatth',
    niyam: dailyNiyam[60],
  });
  calendarDays.set('2025-01-06', {
    tithi: 'Posh Sud Satam',
    niyam: dailyNiyam[61],
  });
  calendarDays.set('2025-01-07', {
    tithi: 'Posh Sud Aatham',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-01-08', {
    tithi: 'Posh Sud Nom',
    niyam: dailyNiyam[62],
  });
  calendarDays.set('2025-01-09', {
    tithi: 'Posh Sud Dasham',
    niyam: dailyNiyam[63],
  });
  calendarDays.set('2025-01-10', {
    tithi: 'Posh Sud Agyaras',
    niyam: dailyNiyam[64],
    shubhDivas: true,
  });
  calendarDays.set('2025-01-11', {
    tithi: 'Posh Sud Baras',
    niyam: dailyNiyam[65],
  });
  calendarDays.set('2025-01-12', {
    tithi: 'Posh Sud Chaudas',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-01-13', {
    tithi: 'Posh Sud Poonam',
    niyam: dailyNiyam[66],
  });
  calendarDays.set('2025-01-14', {
    tithi: 'Posh Vad Ekam',
    niyam: festivalNiyam[0],
  });
  calendarDays.set('2025-01-15', {
    tithi: 'Posh Vad Bij',
    niyam: dailyNiyam[68],
  });
  calendarDays.set('2025-01-16', {
    tithi: 'Posh Vad Trij',
    niyam: dailyNiyam[69],
  });
  calendarDays.set('2025-01-17', {
    tithi: 'Posh Vad Chauth 1',
    niyam: dailyNiyam[70],
  });
  calendarDays.set('2025-01-18', {
    tithi: 'Posh Vad Chauth 2',
    niyam: dailyNiyam[71],
  });
  calendarDays.set('2025-01-19', {
    tithi: 'Posh Vad Pancham',
    shubhDivas: true,
    niyam: dailyNiyam[72],
  });
  calendarDays.set('2025-01-20', {
    tithi: 'Posh Vad Chatth',
    shubhDivas: true,
    niyam: dailyNiyam[73],
  });
  calendarDays.set('2025-01-21', {
    tithi: 'Posh Vad Satam',
    niyam: dailyNiyam[74],
  });
  calendarDays.set('2025-01-22', {
    tithi: 'Posh Vad Aatham',
    niyam: tithiNiyamWithTap,
    shubhDivas: true,
  });
  calendarDays.set('2025-01-23', {
    tithi: 'Posh Vad Nom',
    shubhDivas: true,
    niyam: dailyNiyam[75],
  });
  calendarDays.set('2025-01-24', {
    tithi: 'Posh Vad Dasham',
    niyam: dailyNiyam[76],
    shubhDivas: true,
  });
  calendarDays.set('2025-01-25', {
    tithi: 'Posh Vad Agyaras',
    niyam: dailyNiyam[77],
  });
  calendarDays.set('2025-01-26', {
    tithi: 'Posh Vad Baras',
    niyam: dailyNiyam[78],
  });
  calendarDays.set('2025-01-27', {
    tithi: 'Posh Vad Teras',
    niyam: dailyNiyam[79],
  });
  calendarDays.set('2025-01-28', {
    tithi: 'Posh Vad Chaudas',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-01-29', {
    tithi: 'Posh Vad Amas',
    niyam: dailyNiyam[80],
  });
}

// Mahaa month
// eslint-disable-next-line no-lone-blocks
{
  calendarDays.set('2025-01-30', {
    tithi: 'Maha Sud Ekam',
    niyam: dailyNiyam[81],
  });
  calendarDays.set('2025-01-31', {
    tithi: 'Maha Sud Bij',
    niyam: dailyNiyam[82],
    shubhDivas: true,
  });
  calendarDays.set('2025-02-01', {
    tithi: 'Maha Sud Trij',
    niyam: dailyNiyam[83],
  });
  calendarDays.set('2025-02-02', {
    tithi: 'Maha Sud Pancham',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-02-03', {
    tithi: 'Maha Sud Chatth',
    niyam: dailyNiyam[84],
    shubhDivas: true,
  });
  calendarDays.set('2025-02-04', {
    tithi: 'Maha Sud Satam',
    niyam: dailyNiyam[85],
  });
  calendarDays.set('2025-02-05', {
    tithi: 'Maha Sud Aatham',
    niyam: tithiNiyamWithTap,
    shubhDivas: true,
  });
  calendarDays.set('2025-02-06', {
    tithi: 'Maha Sud Nom',
    niyam: dailyNiyam[86],
  });
  calendarDays.set('2025-02-07', {
    tithi: 'Maha Sud Dasham',
    niyam: dailyNiyam[87],
    shubhDivas: true,
  });
  calendarDays.set('2025-02-08', {
    tithi: 'Maha Sud Agyaras',
    niyam: dailyNiyam[88],
  });
  calendarDays.set('2025-02-09', {
    tithi: 'Maha Sud Baras',
    niyam: dailyNiyam[89],
  });
  calendarDays.set('2025-02-10', {
    tithi: 'Maha Sud Teras',
    niyam: dailyNiyam[90],
    shubhDivas: true,
  });
  calendarDays.set('2025-02-11', {
    tithi: 'Maha Sud Chaudas',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-02-12', {
    tithi: 'Maha Sud Poonam',
    niyam: dailyNiyam[91],
  });
  calendarDays.set('2025-02-13', {
    tithi: 'Maha Vad Ekam',
    niyam: dailyNiyam[92],
  });
  calendarDays.set('2025-02-14', {
    tithi: 'Maha Vad Bij',
    niyam: dailyNiyam[93],
    shubhDivas: true,
  });
  calendarDays.set('2025-02-15', {
    tithi: 'Maha Vad Trij',
    niyam: dailyNiyam[0],
  });
  calendarDays.set('2025-02-16', {
    tithi: 'Maha Vad Chauth',
    niyam: dailyNiyam[1],
  });
  calendarDays.set('2025-02-17', {
    tithi: 'Maha Vad Pancham',
    niyam: dailyNiyam[2],
    shubhDivas: true,
  });
  calendarDays.set('2025-02-18', {
    tithi: 'Maha Vad Chatth 1',
    niyam: dailyNiyam[3],
  });
  calendarDays.set('2025-02-19', {
    tithi: 'Maha Vad Chatth 2',
    niyam: dailyNiyam[4],
  });
  calendarDays.set('2025-02-20', {
    tithi: 'Maha Vad Satam',
    niyam: dailyNiyam[5],
  });
  calendarDays.set('2025-02-21', {
    tithi: 'Maha Vad Aatham',
    niyam: tithiNiyamWithTap,
    shubhDivas: true,
  });
  calendarDays.set('2025-02-22', {
    tithi: 'Maha Vad Nom',
    niyam: dailyNiyam[6],
  });
  calendarDays.set('2025-02-23', {
    tithi: 'Maha Vad Dasham',
    niyam: dailyNiyam[7],
  });
  calendarDays.set('2025-02-24', {
    tithi: 'Maha Vad Agyaras',
    niyam: dailyNiyam[8],
  });
  calendarDays.set('2025-02-25', {
    tithi: 'Maha Vad Baras',
    niyam: dailyNiyam[9],
  });
  calendarDays.set('2025-02-26', {
    tithi: 'Maha Vad Chaudas',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-02-27', {
    tithi: 'Maha Vad Amas',
    niyam: dailyNiyam[10],
  });
}

// Faagan Month
// eslint-disable-next-line no-lone-blocks
{
  calendarDays.set('2025-02-28', {
    tithi: 'Faagan Sud Ekam',
    niyam: dailyNiyam[11],
  });
  calendarDays.set('2025-03-01', {
    tithi: 'Faagan Sud Bij',
    niyam: dailyNiyam[12],
  });
  calendarDays.set('2025-03-02', {
    tithi: 'Faagan Sud Trij',
    niyam: dailyNiyam[13],
    shubhDivas: true,
  });
  calendarDays.set('2025-03-03', {
    tithi: 'Faagan Sud Chauth',
    niyam: dailyNiyam[14],
  });
  calendarDays.set('2025-03-04', {
    tithi: 'Faagan Sud Pancham',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-03-05', {
    tithi: 'Faagan Sud Chatth',
    niyam: dailyNiyam[15],
  });
  calendarDays.set('2025-03-06', {
    tithi: 'Faagan Sud Satam',
    niyam: dailyNiyam[16],
    shubhDivas: true,
  });
  calendarDays.set('2025-03-07', {
    tithi: 'Faagan Sud Aatham',
    niyam: tithiNiyamWithTap,
    shubhDivas: true,
  });
  calendarDays.set('2025-03-08', {
    tithi: 'Faagan Sud Nom',
    niyam: dailyNiyam[17],
  });
  calendarDays.set('2025-03-09', {
    tithi: 'Faagan Sud Dasham',
    niyam: dailyNiyam[18],
    shubhDivas: true,
  });
  calendarDays.set('2025-03-10', {
    tithi: 'Faagan Sud Agyaras',
    niyam: dailyNiyam[19],
  });
  calendarDays.set('2025-03-11', {
    tithi: 'Faagan Sud Baras',
    niyam: dailyNiyam[20],
  });
  calendarDays.set('2025-03-12', {
    tithi: 'Faagan Sud Teras',
    niyam: festivalNiyam[3],
    shubhDivas: true,
  });
  calendarDays.set('2025-03-13', {
    auspiciousEvent: 'Chaumasi Chaudas',
    tithi: 'Faagan Sud Chaudas',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-03-14', {
    tithi: 'Faagan Sud Poonam',
    niyam: dailyNiyam[22],
  });
  calendarDays.set('2025-03-15', {
    tithi: 'Faagan Vad Ekam',
    niyam: dailyNiyam[23],
  });
  calendarDays.set('2025-03-16', {
    tithi: 'Faagan Vad Bij',
    niyam: dailyNiyam[24],
  });
  calendarDays.set('2025-03-17', {
    tithi: 'Faagan Vad Trij',
    niyam: dailyNiyam[25],
  });
  calendarDays.set('2025-03-18', {
    tithi: 'Faagan Vad Chauth',
    niyam: dailyNiyam[26],
  });
  calendarDays.set('2025-03-19', {
    tithi: 'Faagan Vad Pancham',
    niyam: dailyNiyam[27],
  });
  calendarDays.set('2025-03-20', {
    tithi: 'Faagan Vad Chatth',
    niyam: dailyNiyam[28],
    shubhDivas: true,
  });
  calendarDays.set('2025-03-21', {
    tithi: 'Faagan Vad Satam',
    niyam: dailyNiyam[29],
  });
  calendarDays.set('2025-03-22', {
    tithi: 'Faagan Vad Aatham',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-03-23', {
    tithi: 'Faagan Vad Nom',
    niyam: dailyNiyam[30],
  });
  calendarDays.set('2025-03-24', {
    tithi: 'Faagan Vad Dasham',
    niyam: dailyNiyam[31],
    shubhDivas: true,
  });
  calendarDays.set('2025-03-25', {
    tithi: 'Faagan Vad Agyaras',
    niyam: dailyNiyam[32],
  });
  calendarDays.set('2025-03-26', {
    tithi: 'Faagan Vad Baras',
    niyam: dailyNiyam[33],
    shubhDivas: true,
  });
  calendarDays.set('2025-03-27', {
    tithi: 'Faagan Vad Teras',
    niyam: dailyNiyam[34],
  });
  calendarDays.set('2025-03-28', {
    tithi: 'Faagan Vad Chaudas',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-03-29', {
    tithi: 'Faagan Vad Amas',
    niyam: dailyNiyam[35],
  });
}

// Chaitra month
// eslint-disable-next-line no-lone-blocks
{
  calendarDays.set('2025-03-30', {
    tithi: 'Chaitra Sud Ekam',
    niyam: dailyNiyam[36],
  });
  calendarDays.set('2025-03-31', {
    tithi: 'Chaitra Sud Bij',
    niyam: dailyNiyam[37],
  });
  calendarDays.set('2025-04-01', {
    tithi: 'Chaitra Sud Chauth',
    niyam: dailyNiyam[38],
  });
  calendarDays.set('2025-04-02', {
    tithi: 'Chaitra Sud Pancham',
    niyam: tithiNiyamWithTap,
    shubhDivas: true,
  });
  calendarDays.set('2025-04-03', {
    tithi: 'Chaitra Sud Chatth',
    niyam: dailyNiyam[39],
    shubhDivas: true,
  });
  calendarDays.set('2025-04-04', {
    tithi: 'Chaitra Sud Satam (Navpadjini Shashwati Ayambil Odi Day 1)',
    niyam: navpadjiniOliNiyam[0],
  });
  calendarDays.set('2025-04-05', {
    tithi: 'Chaitra Sud Aatham (Navpadjini Shashwati Ayambil Odi Day 2)',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-04-06', {
    tithi: 'Chaitra Sud Nom (Navpadjini Shashwati Ayambil Odi Day 3)',
    niyam: navpadjiniOliNiyam[1],
  });
  calendarDays.set('2025-04-07', {
    tithi: 'Chaitra Sud Dasham (Navpadjini Shashwati Ayambil Odi Day 4)',
    niyam: navpadjiniOliNiyam[2],
  });
  calendarDays.set('2025-04-08', {
    tithi: 'Chaitra Sud Agyaras (Navpadjini Shashwati Ayambil Odi Day 5)',
    niyam: navpadjiniOliNiyam[3],
  });
  calendarDays.set('2025-04-09', {
    tithi: 'Chaitra Sud Baras (Navpadjini Shashwati Ayambil Odi Day 6)',
    niyam: navpadjiniOliNiyam[4],
  });
  calendarDays.set('2025-04-10', {
    tithi: 'Chaitra Sud Teras (Navpadjini Shashwati Ayambil Odi Day 7)',
    niyam: navpadjiniOliNiyam[5],
  });
  calendarDays.set('2025-04-11', {
    tithi: 'Chaitra Sud Chaudas (Navpadjini Shashwati Ayambil Odi Day 8)',
    niyam: tithiNiyamWithAyambilTap,
  });
  calendarDays.set('2025-04-12', {
    tithi: 'Chaitra Sud Poonam (Navpadjini Shashwati Ayambil Odi Day 9)',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-04-13', {
    tithi: 'Chaitra Vad Ekam 1',
    niyam: dailyNiyam[40],
  });
  calendarDays.set('2025-04-14', {
    tithi: 'Chaitra Vad Ekam 2',
    niyam: dailyNiyam[41],
  });
  calendarDays.set('2025-04-15', {
    tithi: 'Chaitra Vad Bij',
    niyam: dailyNiyam[42],
  });
  calendarDays.set('2025-04-16', {
    tithi: 'Chaitra Vad Trij',
    niyam: dailyNiyam[43],
  });
  calendarDays.set('2025-04-17', {
    tithi: 'Chaitra Vad Chauth',
    niyam: dailyNiyam[44],
  });
  calendarDays.set('2025-04-18', {
    tithi: 'Chaitra Vad Pancham',
    niyam: dailyNiyam[45],
  });
  calendarDays.set('2025-04-19', {
    tithi: 'Chaitra Vad Chatth',
    niyam: dailyNiyam[46],
  });
  calendarDays.set('2025-04-20', {
    tithi: 'Chaitra Sud Satam',
    niyam: dailyNiyam[47],
  });
  calendarDays.set('2025-04-21', {
    tithi: 'Chaitra Vad Aatham',
    niyam: tithiNiyamWithTap,
    shubhDivas: true,
  });
  calendarDays.set('2025-04-22', {
    tithi: 'Chaitra Vad Nom',
    niyam: dailyNiyam[48],
  });
  calendarDays.set('2025-04-23', {
    tithi: 'Chaitra Vad Dasham',
    niyam: dailyNiyam[49],
  });
  calendarDays.set('2025-04-24', {
    tithi: 'Chaitra Vad Agyaras',
    niyam: dailyNiyam[50],
    shubhDivas: true,
  });
  calendarDays.set('2025-04-25', {
    tithi: 'Chaitra Vad Baras',
    niyam: dailyNiyam[51],
    shubhDivas: true,
  });
  calendarDays.set('2025-04-26', {
    tithi: 'Chaitra Vad Chaudas',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-04-27', {
    tithi: 'Chaitra Vad Amas',
    niyam: dailyNiyam[52],
  });
}

// Vaishakh Month
// eslint-disable-next-line no-lone-blocks
{
  calendarDays.set('2025-04-28', {
    tithi: 'Vaishakh Sud Ekam',
    niyam: dailyNiyam[49],
  });
  calendarDays.set('2025-04-29', {
    tithi: 'Vaishakh Sud Bij',
    niyam: dailyNiyam[49],
  });
  calendarDays.set('2025-04-30', {
    tithi: 'Vaishakh Sud Trij',
    niyam: dailyNiyam[50],
    shubhDivas: true,
  });
  calendarDays.set('2025-05-01', {
    tithi: 'Vaishakh Sud Chauth',
    niyam: dailyNiyam[51],
  });
  calendarDays.set('2025-05-02', {
    tithi: 'Vaishakh Sud Pancham',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-05-03', {
    tithi: 'Vaishakh Sud Chatth',
    niyam: dailyNiyam[52],
  });
  calendarDays.set('2025-05-04', {
    tithi: 'Vaishakh Sud Satam',
    niyam: dailyNiyam[53],
  });
  calendarDays.set('2025-05-05', {
    tithi: 'Vaishakh Sud Aatham',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-05-06', {
    tithi: 'Vaishakh Sud Nom',
    niyam: dailyNiyam[55],
  });
  calendarDays.set('2025-05-07', {
    tithi: 'Vaishakh Sud Dasham',
    niyam: dailyNiyam[56],
  });
  calendarDays.set('2025-05-08', {
    tithi: 'Vaishakh Sud Agyaras',
    niyam: dailyNiyam[57],
  });
  calendarDays.set('2025-05-09', {
    tithi: 'Vaishakh Sud Baras',
    niyam: dailyNiyam[58],
    shubhDivas: true,
  });
  calendarDays.set('2025-05-10', {
    tithi: 'Vaishakh Sud Teras',
    niyam: dailyNiyam[59],
  });
  calendarDays.set('2025-05-11', {
    tithi: 'Vaishakh Sud Chaudas',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-05-12', {
    tithi: 'Vaishakh Sud Poonam',
    niyam: festivalNiyam[2],
  });
  calendarDays.set('2025-05-13', {
    tithi: 'Vaishakh Vad Ekam',
    niyam: dailyNiyam[61],
  });
  calendarDays.set('2025-05-14', {
    tithi: 'Vaishakh Vad Bij',
    niyam: dailyNiyam[62],
    shubhDivas: true,
  });
  calendarDays.set('2025-05-15', {
    tithi: 'Vaishakh Vad Trij',
    niyam: dailyNiyam[63],
  });
  calendarDays.set('2025-05-16', {
    tithi: 'Vaishakh Vad Chauth',
    niyam: dailyNiyam[64],
  });
  calendarDays.set('2025-05-17', {
    tithi: 'Vaishakh Vad Pancham',
    niyam: dailyNiyam[65],
  });
  calendarDays.set('2025-05-18', {
    tithi: 'Vaishakh Vad Chatth 1',
    niyam: dailyNiyam[66],
  });
  calendarDays.set('2025-05-19', {
    tithi: 'Vaishakh Sud Chatth 2',
    niyam: festivalNiyam[1],
  });
  calendarDays.set('2025-05-20', {
    tithi: 'Vaishakh Vad Aatham',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-05-21', {
    tithi: 'Vaishakh Vad Nom',
    niyam: dailyNiyam[68],
  });
  calendarDays.set('2025-05-22', {
    tithi: 'Vaishakh Vad Dasham',
    niyam: dailyNiyam[69],
  });
  calendarDays.set('2025-05-23', {
    tithi: 'Vaishakh Vad Agyaras',
    niyam: dailyNiyam[69],
    shubhDivas: true,
  });
  calendarDays.set('2025-05-24', {
    tithi: 'Vaishakh Vad Baras',
    niyam: dailyNiyam[70],
  });
  calendarDays.set('2025-05-25', {
    tithi: 'Vaishakh Vad Teras',
    niyam: dailyNiyam[71],
  });
  calendarDays.set('2025-05-26', {
    tithi: 'Vaishakh Vad Chaudas',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-05-27', {
    tithi: 'Vaishakh Vad Amas',
    niyam: dailyNiyam[72],
  });
}

// Jeth month
// eslint-disable-next-line no-lone-blocks
{
  calendarDays.set('2025-05-28', {
    tithi: 'Jeth Sud Bij',
    niyam: dailyNiyam[73],
  });
  calendarDays.set('2025-05-29', {
    tithi: 'Jeth Sud Trij',
    niyam: dailyNiyam[74],
  });
  calendarDays.set('2025-05-30', {
    tithi: 'Jeth Sud Chauth',
    niyam: dailyNiyam[75],
  });
  calendarDays.set('2025-05-31', {
    tithi: 'Jeth Sud Pancham',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-06-01', {
    tithi: 'Jeth Sud Chatth',
    niyam: dailyNiyam[76],
  });
  calendarDays.set('2025-06-02', {
    tithi: 'Jeth Sud Satam',
    niyam: dailyNiyam[77],
  });
  calendarDays.set('2025-06-03', {
    tithi: 'Jeth Sud Aatham',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-06-04', {
    tithi: 'Jeth Sud Nom',
    niyam: dailyNiyam[78],
  });
  calendarDays.set('2025-06-05', {
    tithi: 'Jeth Sud Dasham',
    niyam: dailyNiyam[39],
    shubhDivas: true,
  });
  calendarDays.set('2025-06-06', {
    tithi: 'Jeth Sud Agyaras',
    niyam: dailyNiyam[79],
  });
  calendarDays.set('2025-06-07', {
    tithi: 'Jeth Sud Baras 1',
    niyam: dailyNiyam[80],
  });
  calendarDays.set('2025-06-08', {
    tithi: 'Jeth Sud Baras 2',
    niyam: dailyNiyam[81],
  });
  calendarDays.set('2025-06-09', {
    tithi: 'Jeth Sud Teras',
    niyam: dailyNiyam[82],
  });
  calendarDays.set('2025-06-10', {
    tithi: 'Jeth Sud Chaudas',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-06-11', {
    tithi: 'Jeth Sud Poonam',
    niyam: dailyNiyam[83],
  });
  calendarDays.set('2025-06-12', {
    tithi: 'Jeth Vad Ekam',
    niyam: dailyNiyam[84],
  });
  calendarDays.set('2025-06-13', {
    tithi: 'Jeth Vad Bij',
    niyam: dailyNiyam[85],
  });
  calendarDays.set('2025-06-14', {
    tithi: 'Jeth Vad Trij',
    niyam: dailyNiyam[86],
    shubhDivas: true,
  });
  calendarDays.set('2025-06-15', {
    tithi: 'Jeth Vad Chauth',
    niyam: dailyNiyam[87],
  });
  calendarDays.set('2025-06-16', {
    tithi: 'Jeth Vad Pancham',
    niyam: dailyNiyam[88],
    shubhDivas: true,
  });
  calendarDays.set('2025-06-17', {
    tithi: 'Jeth Vad Chatth',
    niyam: dailyNiyam[89],
  });
  calendarDays.set('2025-06-18', {
    tithi: 'Jeth Vad Satam',
    niyam: dailyNiyam[90],
  });
  calendarDays.set('2025-06-19', {
    tithi: 'Jeth Vad Aatham',
    niyam: tithiNiyamWithTap,
    shubhDivas: true,
  });
  calendarDays.set('2025-06-20', {
    tithi: 'Jeth Vad Nom',
    niyam: dailyNiyam[91],
  });
  calendarDays.set('2025-06-21', {
    tithi: 'Jeth Vad Agyaras',
    niyam: dailyNiyam[92],
  });
  calendarDays.set('2025-06-22', {
    tithi: 'Jeth Vad Baras',
    niyam: dailyNiyam[93],
    shubhDivas: true,
  });
  calendarDays.set('2025-06-23', {
    tithi: 'Jeth Vad Teras',
    niyam: dailyNiyam[0],
  });
  calendarDays.set('2025-06-24', {
    tithi: 'Jeth Vad Chaudas',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-06-25', {
    tithi: 'Jeth Vad Amas',
    niyam: dailyNiyam[1],
  });
}

// Ashaadh month
// eslint-disable-next-line no-lone-blocks
{
  calendarDays.set('2025-06-26', {
    tithi: 'Ashaadh Sud Ekam',
    niyam: dailyNiyam[2],
  });
  calendarDays.set('2025-06-27', {
    tithi: 'Ashaadh Sud Bij',
    niyam: dailyNiyam[3],
    shubhDivas: true,
  });
  calendarDays.set('2025-06-28', {
    tithi: 'Ashaadh Sud Trij',
    niyam: dailyNiyam[4],
  });
  calendarDays.set('2025-06-29', {
    tithi: 'Ashaadh Sud Chauth',
    niyam: dailyNiyam[5],
  });
  calendarDays.set('2025-06-30', {
    tithi: 'Ashaadh Sud Pancham',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-07-01', {
    tithi: 'Ashaadh Sud Chatth',
    niyam: dailyNiyam[6],
  });
  calendarDays.set('2025-07-02', {
    tithi: 'Ashaadh Sud Satam',
    niyam: dailyNiyam[7],
    shubhDivas: true,
  });
  calendarDays.set('2025-07-03', {
    tithi: 'Ashaadh Sud Aatham',
    niyam: tithiNiyamWithTap,
    shubhDivas: true,
  });
  calendarDays.set('2025-07-04', {
    tithi: 'Ashaadh Sud Nom',
    niyam: dailyNiyam[8],
  });
  calendarDays.set('2025-07-05', {
    tithi: 'Ashaadh Sud Dasham',
    niyam: dailyNiyam[9],
    shubhDivas: true,
  });
  calendarDays.set('2025-07-06', {
    tithi: 'Ashaadh Sud Agyaras',
    niyam: dailyNiyam[10],
  });
  calendarDays.set('2025-07-07', {
    tithi: 'Ashaadh Sud Baras',
    niyam: dailyNiyam[11],
    shubhDivas: true,
  });
  calendarDays.set('2025-07-08', {
    tithi: 'Ashaadh Sud Teras',
    niyam: dailyNiyam[12],
  });
  calendarDays.set('2025-07-09', {
    tithi: 'Ashaadh Sud Chaudas',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-07-10', {
    tithi: 'Ashaadh Sud Poonam',
    niyam: dailyNiyam[13],
  });
  calendarDays.set('2025-07-11', {
    tithi: 'Ashaadh Vad Ekam',
    niyam: dailyNiyam[14],
  });
  calendarDays.set('2025-07-12', {
    tithi: 'Ashaadh Vad Bij',
    niyam: dailyNiyam[15],
  });
  calendarDays.set('2025-07-13', {
    tithi: 'Ashaadh Vad Trij',
    niyam: dailyNiyam[16],
    shubhDivas: true,
  });
  calendarDays.set('2025-07-14', {
    tithi: 'Ashaadh Sud Chauth',
    niyam: dailyNiyam[17],
  });
  calendarDays.set('2025-07-15', {
    tithi: 'Ashaadh Vad Pancham',
    niyam: dailyNiyam[18],
  });
  calendarDays.set('2025-07-16', {
    tithi: 'Ashaadh Vad Chatth',
    niyam: dailyNiyam[19],
  });
  calendarDays.set('2025-07-17', {
    tithi: 'Ashaadh Vad Satam',
    niyam: dailyNiyam[20],
  });
  calendarDays.set('2025-07-18', {
    tithi: 'Ashaadh Vad Aatham',
    niyam: tithiNiyamWithTap,
    shubhDivas: true,
  });
  calendarDays.set('2025-07-19', {
    tithi: 'Ashaadh Vad Nom',
    niyam: dailyNiyam[21],
  });
  calendarDays.set('2025-07-20', {
    tithi: 'Ashaadh Vad Dasham',
    niyam: dailyNiyam[22],
  });
  calendarDays.set('2025-07-21', {
    tithi: 'Ashaadh Vad Agyaras',
    niyam: dailyNiyam[23],
    shubhDivas: true,
  });
  calendarDays.set('2025-07-22', {
    tithi: 'Ashaadh Vad Baras',
    niyam: dailyNiyam[24],
  });
  calendarDays.set('2025-07-23', {
    tithi: 'Ashaadh Vad Chaudas',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-07-24', {
    tithi: 'Ashaadh Vad Amas',
    niyam: dailyNiyam[25],
  });
}

// Shraavan month
// eslint-disable-next-line no-lone-blocks
{
  calendarDays.set('2025-07-25', {
    tithi: 'Shraavan Sud Ekam',
    niyam: dailyNiyam[27],
  });
  calendarDays.set('2025-07-26', {
    tithi: 'Shraavan Sud Bij',
    niyam: dailyNiyam[28],
  });
  calendarDays.set('2025-07-27', {
    tithi: 'Shraavan Sud Trij',
    niyam: dailyNiyam[29],
  });
  calendarDays.set('2025-07-28', {
    tithi: 'Shraavan Sud Chauth',
    niyam: dailyNiyam[30],
  });
  calendarDays.set('2025-07-29', {
    tithi: 'Shraavan Sud Pancham',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-07-30', {
    tithi: 'Shraavan Sud Chatth',
    niyam: dailyNiyam[31],
    shubhDivas: true,
  });
  calendarDays.set('2025-07-31', {
    tithi: 'Shraavan Sud Satam 1',
    niyam: dailyNiyam[32],
    shubhDivas: true,
  });
  calendarDays.set('2025-08-01', {
    tithi: 'Shraavan Sud Satam 2',
    niyam: dailyNiyam[33],
  });
  calendarDays.set('2025-08-02', {
    tithi: 'Shraavan Sud Aatham',
    niyam: tithiNiyamWithTap,
    shubhDivas: true,
  });
  calendarDays.set('2025-08-03', {
    tithi: 'Shraavan Sud Nom',
    niyam: dailyNiyam[34],
  });
  calendarDays.set('2025-08-04', {
    tithi: 'Shraavan Sud Dasham',
    niyam: dailyNiyam[35],
  });
  calendarDays.set('2025-08-05', {
    tithi: 'Shraavan Sud Agyaras',
    niyam: dailyNiyam[36],
  });
  calendarDays.set('2025-08-06', {
    tithi: 'Shraavan Sud Baras',
    niyam: dailyNiyam[37],
  });
  calendarDays.set('2025-08-07', {
    tithi: 'Shraavan Sud Teras',
    niyam: dailyNiyam[26],
  });
  calendarDays.set('2025-08-08', {
    tithi: 'Shraavan Sud Chaudas',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-08-09', {
    tithi: 'Shraavan Sud Poonam',
    niyam: dailyNiyam[38],
  });
  calendarDays.set('2025-08-10', {
    tithi: 'Shraavan Vad Ekam',
    niyam: dailyNiyam[39],
  });
  calendarDays.set('2025-08-11', {
    tithi: 'Shraavan Vad Bij',
    niyam: dailyNiyam[40],
    shubhDivas: true,
  });
  calendarDays.set('2025-08-12', {
    tithi: 'Shraavan Vad Trij',
    niyam: dailyNiyam[41],
  });
  calendarDays.set('2025-08-13', {
    tithi: 'Shraavan Vad Pancham',
    niyam: dailyNiyam[42],
  });
  calendarDays.set('2025-08-14', {
    tithi: 'Shraavan Vad Chatth',
    niyam: dailyNiyam[43],
    shubhDivas: true,
  });
  calendarDays.set('2025-08-15', {
    tithi: 'Shraavan Vad Satam',
    niyam: dailyNiyam[44],
  });
  calendarDays.set('2025-08-16', {
    tithi: 'Shraavan Vad Aatham',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-08-17', {
    tithi: 'Shraavan Vad Nom',
    niyam: dailyNiyam[45],
  });
  calendarDays.set('2025-08-18', {
    tithi: 'Shraavan Vad Dasham',
    niyam: dailyNiyam[46],
  });
  calendarDays.set('2025-08-19', {
    tithi: 'Shraavan Vad Agyaras',
    niyam: dailyNiyam[47],
  });
  calendarDays.set('2025-08-20', {
    tithi: 'Shraavan Vad Baras',
    niyam: dailyNiyam[48],
    shubhDivas: true,
  });
  calendarDays.set('2025-08-21', {
    tithi: 'Shraavan Vad Teras',
    niyam: dailyNiyam[49],
  });
  calendarDays.set('2025-08-22', {
    tithi: 'Shraavan Vad Chaudas',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-08-23', {
    tithi: 'Shraavan Vad Amas',
    niyam: dailyNiyam[50],
  });
}

// Bhadarvo month
// eslint-disable-next-line no-lone-blocks
{
  calendarDays.set('2025-08-24', {
    tithi: 'Bhadarvo Sud Ekam',
    niyam: dailyNiyam[51],
  });
  calendarDays.set('2025-08-25', {
    tithi: 'Bhadarvo Sud Bij',
    niyam: dailyNiyam[52],
    shubhDivas: true,
  });
  calendarDays.set('2025-08-26', {
    tithi: 'Bhadarvo Sud Trij',
    niyam: dailyNiyam[53],
  });
  calendarDays.set('2025-08-27', {
    tithi: 'Bhadarvo Sud Chauth',
    niyam: dailyNiyam[54],
  });
  calendarDays.set('2025-08-28', {
    tithi: 'Bhadarvo Sud Pancham',
    niyam: tithiNiyamWithTap,
    shubhDivas: true,
  });
  calendarDays.set('2025-08-29', {
    tithi: 'Bhadarvo Sud Chatth',
    niyam: dailyNiyam[55],
    shubhDivas: true,
  });
  calendarDays.set('2025-08-30', {
    tithi: 'Bhadarvo Sud Satam',
    niyam: dailyNiyam[56],
  });
  calendarDays.set('2025-08-31', {
    tithi: 'Bhadarvo Sud Aatham',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-09-01', {
    tithi: 'Bhadarvo Sud Nom',
    niyam: dailyNiyam[57],
  });
  calendarDays.set('2025-09-02', {
    tithi: 'Bhadarvo Sud Dasham',
    niyam: dailyNiyam[58],
  });
  calendarDays.set('2025-09-03', {
    tithi: 'Bhadarvo Sud Agyaras',
    niyam: dailyNiyam[59],
  });
  calendarDays.set('2025-09-04', {
    tithi: 'Bhadarvo Sud Baras',
    niyam: dailyNiyam[60],
    shubhDivas: true,
  });
  calendarDays.set('2025-09-05', {
    tithi: 'Bhadarvo Sud Teras',
    niyam: dailyNiyam[61],
    shubhDivas: true,
  });
  calendarDays.set('2025-09-06', {
    tithi: 'Bhadarvo Sud Chaudas',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-09-07', {
    tithi: 'Bhadarvo Sud Poonam',
    niyam: dailyNiyam[62],
  });
  calendarDays.set('2025-09-08', {
    tithi: 'Bhadarvo Vad Ekam',
    niyam: dailyNiyam[63],
  });
  calendarDays.set('2025-09-09', {
    tithi: 'Bhadarvo Vad Bij',
    niyam: dailyNiyam[64],
    shubhDivas: true,
  });
  calendarDays.set('2025-09-10', {
    tithi: 'Bhadarvo Vad Trij',
    niyam: dailyNiyam[65],
  });
  calendarDays.set('2025-09-11', {
    tithi: 'Bhadarvo Vad Chauth',
    niyam: dailyNiyam[66],
  });
  calendarDays.set('2025-09-12', {
    tithi: 'Bhadarvo Vad Pancham',
    niyam: dailyNiyam[67],
    shubhDivas: true,
  });
  calendarDays.set('2025-09-13', {
    tithi: 'Bhadarvo Vad Chatth',
    niyam: dailyNiyam[68],
  });
  calendarDays.set('2025-09-14', {
    tithi: 'Bhadarvo Vad Aatham',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-09-15', {
    tithi: 'Bhadarvo Vad Nom',
    niyam: dailyNiyam[69],
  });
  calendarDays.set('2025-09-16', {
    tithi: 'Bhadarvo Vad Dasham',
    niyam: dailyNiyam[70],
  });
  calendarDays.set('2025-09-17', {
    tithi: 'Bhadarvo Vad Agyaras',
    niyam: dailyNiyam[71],
    shubhDivas: true,
  });
  calendarDays.set('2025-09-18', {
    tithi: 'Bhadarvo Vad Baras',
    niyam: dailyNiyam[72],
    shubhDivas: true,
  });
  calendarDays.set('2025-09-19', {
    tithi: 'Bhadarvo Vad Teras',
    niyam: dailyNiyam[73],
  });
  calendarDays.set('2025-09-20', {
    tithi: 'Bhadarvo Vad Chaudas',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-09-21', {
    tithi: 'Bhadarvo Vad Amas',
    niyam: dailyNiyam[74],
  });
}

// Aaso month
// eslint-disable-next-line no-lone-blocks
{
  calendarDays.set('2025-09-22', {
    tithi: 'Aaso Sud Ekam',
    niyam: dailyNiyam[75],
  });
  calendarDays.set('2025-09-23', {
    tithi: 'Aaso Sud Bij',
    niyam: dailyNiyam[76],
  });
  calendarDays.set('2025-09-24', {
    tithi: 'Aaso Sud Trij 1',
    niyam: dailyNiyam[77],
  });
  calendarDays.set('2025-09-25', {
    tithi: 'Aaso Sud Trij 2',
    niyam: dailyNiyam[78],
  });
  calendarDays.set('2025-09-26', {
    tithi: 'Aaso Sud Chauth',
    niyam: dailyNiyam[79],
  });
  calendarDays.set('2025-09-27', {
    tithi: 'Aaso Sud Pancham',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-09-28', {
    tithi: 'Aaso Sud Chatth',
    niyam: dailyNiyam[80],
  });
  calendarDays.set('2025-09-29', {
    tithi: 'Aaso Sud Satam',
    niyam: navpadjiniOliNiyam[0],
  });
  calendarDays.set('2025-09-30', {
    tithi: 'Aaso Sud Aatham',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-10-01', {
    tithi: 'Aaso Sud Nom',
    niyam: navpadjiniOliNiyam[1],
  });
  calendarDays.set('2025-10-02', {
    tithi: 'Aaso Sud Dasham',
    niyam: navpadjiniOliNiyam[2],
  });
  calendarDays.set('2025-10-03', {
    tithi: 'Aaso Sud Agyaras',
    niyam: navpadjiniOliNiyam[3],
  });
  calendarDays.set('2025-10-04', {
    tithi: 'Aaso Sud Baras',
    niyam: navpadjiniOliNiyam[4],
  });
  calendarDays.set('2025-10-05', {
    tithi: 'Aaso Sud Teras',
    niyam: navpadjiniOliNiyam[5],
  });
  calendarDays.set('2025-10-06', {
    tithi: 'Aaso Sud Chaudas',
    niyam: tithiNiyamWithAyambilTap,
  });
  calendarDays.set('2025-10-07', {
    tithi: 'Aaso Sud Poonam',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-10-08', {
    tithi: 'Aaso Vad Bij',
    niyam: dailyNiyam[88],
    shubhDivas: true,
  });
  calendarDays.set('2025-10-09', {
    tithi: 'Aaso Vad Trij',
    niyam: dailyNiyam[89],
  });
  calendarDays.set('2025-10-10', {
    tithi: 'Aaso Vad Chauth',
    niyam: dailyNiyam[90],
  });
  calendarDays.set('2025-10-11', {
    tithi: 'Aaso Vad Pancham',
    niyam: dailyNiyam[91],
  });
  calendarDays.set('2025-10-12', {
    tithi: 'Aaso Vad Chatth',
    niyam: dailyNiyam[92],
    shubhDivas: true,
  });
  calendarDays.set('2025-10-13', {
    tithi: 'Aaso Vad Satam',
    niyam: dailyNiyam[93],
  });
  calendarDays.set('2025-10-14', {
    tithi: 'Aaso Vad Aatham',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-10-15', {
    tithi: 'Aaso Vad Nom',
    niyam: dailyNiyam[0],
  });
  calendarDays.set('2025-10-16', {
    tithi: 'Aaso Vad Dasham',
    niyam: dailyNiyam[1],
  });
  calendarDays.set('2025-10-17', {
    tithi: 'Aaso Vad Agyaras',
    niyam: dailyNiyam[2],
  });
  calendarDays.set('2025-10-18', {
    tithi: 'Aaso Vad Baras',
    niyam: dailyNiyam[3],
    shubhDivas: true,
  });
  calendarDays.set('2025-10-19', {
    tithi: 'Aaso Vad Teras',
    niyam: dailyNiyam[4],
  });
  calendarDays.set('2025-10-20', {
    tithi: 'Aaso Vad Chaudas',
    niyam: tithiNiyamWithTap,
  });
  calendarDays.set('2025-10-21', {
    tithi: 'Aaso Vad Amas',
    niyam: dailyNiyam[5],
  });
}
